<script lang="ts" setup>
const isFullscreenVisible = ref(false);

const { t } = useI18n();

const [modalVisible, onToggleVisible] = useExternalModalState(
  isFullscreenVisible,
  (v) => (isFullscreenVisible.value = v),
);
</script>

<template>
  <button @click="isFullscreenVisible = true" class="contentProseImg">
    <NuxtImg format="webp" width="700" v-bind="$attrs" class="contentProseImg__image" />
  </button>

  <BaseModal
    :visible="modalVisible"
    @update:visible="onToggleVisible"
    fullscreen
    :aria-title="t('title')"
    :aria-describedby="t('description')"
  >
    <NuxtImg
      format="webp"
      :src="$attrs.src as string"
      :alt="$attrs.alt as string"
      :sizes="IMAGE_SIZES.fullscreen"
      class="contentProseImg__fullscreen"
    />
  </BaseModal>
</template>

<i18n>
ru:
  title: Просмотр изображения
  description: Просмотр изображения в полноэкранном режиме

en:
  title: View image
  description: View image in full screen
</i18n>

<style lang="scss">
.contentProseImg {
  display: block;
  padding: 0;
  border: 0;
  cursor: pointer;

  &__image {
    display: block;
    width: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1;
  }

  &__fullscreen {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}
</style>
